
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M9 6V3L5 7h3a1 1 0 001-1zm9.18-3H11v5a1 1 0 01-1 1H5v11.1a.86.86 0 00.82.9h12.36a.86.86 0 00.82-.9V3.9a.86.86 0 00-.82-.9z"}})])
          )
        }
      }
    